<template>
  <div>
    <b-container fluid class="d-flex align-items-center  back-wrapper">
          <b-row class="full-width">
            <b-col lg="7" md="10">
              <router-link :to="{name: 'ordenesStatus'}" class="back-item">
                  <img class="arrow-back" src="img/theme/icn_arrowback.svg" alt="">
                  <span>Estatus de pedidos</span>
              </router-link>
            </b-col>
          </b-row>
        </b-container>
    <div class="header pb-8 pt-5 pt-lg-6 d-flex align-items-center profile-header">
      <b-container fluid>
        <!-- Mask -->
        <span class="mask"></span>
        <!-- Header container -->
        <h1 class="text-center">Panel de Configuración</h1>
      </b-container>
    </div>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <b-card class="statusOrders" no-body>
            <b-card-header class="border-0">
            </b-card-header>
            <b-row>
              <b-col md="3">
                <multiselect
                      :show-labels="false"
                      v-model="status"
                      :options="['Todos los estados','Solicitud', 'Producción', 'Proceso de importación', 'Almacen Domik', 'Bordado', 'Pick & Pack', 'Calidad', 'Pendientes de entrega', 'En tránsito a destino', 'Entregado', 'Rechazado']"
                      placeholder='Selecciona el estatus'
                      class="mb-3"
                      name="status"
                      :allow-empty="false"
                >
                </multiselect>
              </b-col>
              <b-col md="3">
                <multiselect
                      :show-labels="false"
                      v-model="hospitalList"
                      :options="hospitals"
                      class="mb-3"
                      :multiple="true"
                      placeholder='Selecciona el hospital a visualizar'
                      label="name"
                      track-by="id"
                      value-prop="id"
                      style="max-width: 350px; margin-left: 20px;"
                      >
                </multiselect>
              </b-col>
              <b-col>
                <multiselect
                      :show-labels="false"
                      v-model="statusBulk"
                      :options="['Solicitud', 'Producción', 'Proceso de importación', 'Almacen Domik', 'Bordado', 'Pick & Pack', 'Calidad', 'En tránsito a destino', 'Pendientes de entrega', 'Entregado', 'Rechazado']"
                      placeholder='Selecciona una opción'
                      name="status"
                      required
                      >
                </multiselect>
              </b-col>
            </b-row>

            <el-table class="table-responsive table"
                      header-row-class-name="thead-light"
                      @row-click="showModalOrder"
                      :data="pagedTableData"
                      :key="count">

                <el-table-column width="50px">
                    <template v-slot:header>
                      <base-checkbox
                        v-model="allSelected"
                      >
                      </base-checkbox>
                    </template>
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                          <base-checkbox
                            v-model="row.selected"
                          >
                          </base-checkbox>
                        </b-media>
                    </template>
                </el-table-column>
                <el-table-column label="No. Orden"
                          width="120px"
                          prop="name">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                            <router-link
                                :to="{
                                  name: 'ordenesStatusEdit',
                                  params: { orderId: row.id },
                                }">
                                    {{row.id}}
                            </router-link>
                        </b-media>
                    </template>
                </el-table-column>
                <el-table-column label="Nombre"
                                  prop="name">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                            {{row.name}} {{row.first_lastname}} {{row.second_lastname}}
                        </b-media>
                    </template>
                </el-table-column>

                <el-table-column  label="Hospital"
                                  prop="hospital">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                            {{row.hospital}}
                        </b-media>
                    </template>
                </el-table-column>
                <el-table-column label="Fecha"
                                  prop="date">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                            {{row.date}}
                        </b-media>
                    </template>
                </el-table-column>
                <el-table-column label="ESTATUS"
                                  prop="status">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                            {{row.status}}
                        </b-media>
                    </template>
                </el-table-column>
                <el-table-column label=""
                          prop=""
                          width="80px"
                          style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                          <router-link
                            :to="{
                              name: 'ordenesStatusEdit',
                              params: { orderId: row.id },
                            }">
                                <img src="img/theme/icn_edit.svg" alt="">
                            </router-link>
                        </b-media>
                    </template>
                </el-table-column>
            </el-table>
            <b-card-footer class="py-4 d-flex justify-content-end">
                <base-pagination v-model="currentPage" :per-page="10" @change="setPage"  :total="pagedTableData.length"></base-pagination>
            </b-card-footer>
        </b-card>
        </b-col>
      </b-row>
    </b-container>
    <modal :show.sync="searchModalVisible"
            class="modal-search"
            id="searchModal"
            :centered="true"
            :show-close="true">
            Las órdenes seleccionadas cambiarán su estado a <b>"{{ statusBulk }}"</b>
            <template slot="footer">
              <button type="button"
                      class="btn btn-primary px-4"
                      @click="updateOrders">
                Aceptar
              </button>
              <b-button variant="danger"
                        class="px-4"
                        @click="searchModalVisible = false">
                Cancelar
              </b-button>

            </template>
    </modal>
  </div>
</template>
<script>
  import axios from 'axios'
  import qs from 'qs'
  import { Dropdown, DropdownItem, DropdownMenu, Table, TableColumn } from 'element-ui'
  import Multiselect from 'vue-multiselect'
  import Modal from '@/components/Modal'

  export default {
    data() {
      return {
        allSelected: false,
        orders: [],
        test: [],
        hospitals:'',
        hospitalList: '',
        token:'',
        user:'',
        currentPage: 1,
        pageSize: 10,
        search: '',
        statusBulk: '',
        searchModalVisible: false,
        status: 'Todos los estados',
        count: 0
      };
    },
    components: {
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      Multiselect,
      Modal

    },
    async created () {
      this.token = localStorage.getItem('token')
      this.user = localStorage.getItem('id_user')
      await axios
      .post(
        process.env.VUE_APP_ROUTE_BACKEND_API+'orders_api.php',
        qs.stringify({ api_token: this.token, user_id: this.user, option: 'get_orders'}),
      )
      .then((response) => {
        if (!response.data.error.code && response.data.orders) {
          let temp = []
          Object.keys(response.data.orders).map((key) => [response.data.orders[key]]).map(function(value) {
              value[0]['selected'] = false
              temp.push(value[0])
          })
          this.orders = temp
        }
      })
      .catch((err) => {
        console.log(err)
      })
      await axios
      .post(
        process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
        qs.stringify({ api_token: this.token, user_id: this.user, option: 'get_catalogs'}),
      )
      .then((response) => {
        if (!response.data.error.code && response.data.hospitals) {
          let tempH = []
          Object.keys(response.data.hospitals).map((key) => [response.data.hospitals[key]]).map(function(value) {
              tempH.push(value[0])
          })
          this.hospitals = tempH
        }
      })
      .catch((err) => {
        console.log(err)
      })
    },
    computed: {
      pagedTableData() {
        let filteredH
        if(this.hospitalList.length>0){
          filteredH = this.hospitalList.map(z => z.id)
        }
        if(filteredH)
        console.log(this.orders.filter(data => filteredH[0]==data.id_hospital))
        return this.orders.filter(data => this.status !== 'Todos los estados' ? data.status.includes(this.status) : data).filter(data => this.hospitalList.length ? filteredH.includes(data.id_hospital): data).slice(this.pageSize * this.currentPage - this.pageSize, this.pageSize * this.currentPage)
      }
    },
    methods : {
      setPage (val) {
        this.currentPage = val
      },
      showModalOrder (index) {
        // console.log(index)
      },
      onCheckboxChange(index) {
          this.searchModalVisible = true
      },
      updateOrders() {
        this.searchModalVisible = false
        this.token = localStorage.getItem('token')
        this.user = localStorage.getItem('id_user')
        axios
        .post(
          process.env.VUE_APP_ROUTE_BACKEND_API+'orders_api.php',
          qs.stringify({
            api_token: this.token,
            user_id: this.user,
            option: 'bulk_edit_order_status',
            order_id_list: this.orders.filter(data => data.selected==true).map((elem) => elem.id).toString(),
            order_status: this.statusBulk
          }),
        )
        .then((response) => {
          if (!response.data.error.code) {
            this.success = true
          } else {
            this.success = false
            this.error = response.data.error.description
          }
        })
        .catch((err) => {
          console.log(err)
        })
        this.count++
      }
    },
    watch: {
        allSelected: {
          handler(value){
              if(value){
                this.pagedTableData.forEach((element) => element.selected = true )
              } else {
                this.pagedTableData.forEach((element) => element.selected = false )
              }
            }
        },
        statusBulk: {
            handler(value){
              var selectedOrders = this.orders.filter(data => data.selected==true)
              if(value && selectedOrders.length>0){
                this.searchModalVisible = true
              }
            }
        }
    },
  };
</script>
<style>
.el-table, a{
  color: #112357;
}
.full-width{
  width: 100%;
}
.statusOrders .multiselect__tags{
    /* border: none !important; */
}
.statusOrders .multiselect,
.statusOrders .multiselect__input,
.statusOrders .multiselect__single{
  max-width: 300px;
  font-size: 15px;
  margin-left: 15px;
}
.statusOrders .multiselect__single{
  color: #112357;
  font-weight: bold;
  font-size: 15px;
}
.statusOrders .multiselect__placeholder{
  color: #112357;
  font-weight: bold;
  font-size: 15px;
}
.statusOrders .multiselect__placeholder::after,
.statusOrders .multiselect__single::after {
    margin-left: 8px;
    border-style: solid;
    border-width: 0.25em 0.25em 0 0;
    content: '';
    display: inline-block;
    height: 0.7em;
    left: 0.15em;
    position: relative;
    top: 0.2em;
    transform: rotate(135deg);
    vertical-align: top;
    width: 0.7em;
}
@media (max-width: 1600px) {
  .statusOrders .multiselect,
  .statusOrders .multiselect__input,
  .statusOrders .multiselect__single {
    font-size: 0.85rem;
  }
}
</style>
